var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7814 11.8902L13.0786 9.95294H11.2198V8.69633C11.2198 8.1662 11.479 7.64915 12.3115 7.64915H13.1571V5.99985C13.1571 5.99985 12.3901 5.86896 11.657 5.86896C10.1255 5.86896 9.12549 6.79702 9.12549 8.47642V9.95294H7.42383V11.8902H9.12549V16.5737C9.46713 16.6274 9.81662 16.6549 10.1727 16.6549C10.5287 16.6549 10.8782 16.6274 11.2198 16.5737V11.8902H12.7814Z",
    fill: "#a4b0d0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.611328,
    y: 1.45056,
    width: 19.3609,
    height: 19.3609,
    rx: 9.68044,
    stroke: "#a4b0d0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.f634732d297a1b62e382b38ec65a6667.svg";
export { ForwardRef as ReactComponent };